import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Clock } from 'lucide-react';
import { Button } from './ui/Button';
export function FinalOffer() {
  return <section className="py-20 relative z-10 bg-[#0a0517] overflow-hidden text-center" data-id="element-30">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[1000px] h-[1000px] bg-gradient-to-b from-[#7c3aed]/20 to-[#fbbf24]/10 rounded-full blur-[150px] pointer-events-none" data-id="element-31" />

      <div className="container mx-auto px-4 relative z-10" data-id="element-32">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="max-w-3xl mx-auto" data-id="element-33">
          <div className="inline-flex items-center gap-2 px-6 py-2 rounded-full bg-red-500/10 border border-red-500/30 text-red-400 mb-6 animate-pulse" data-id="element-34">
            <Clock className="w-5 h-5" data-id="element-35" />
            <span className="font-bold tracking-wider uppercase text-sm" data-id="element-36">
              Oferta por tiempo limitado
            </span>
          </div>

          <h2 className="text-3xl md:text-5xl font-bold mb-6 leading-tight" data-id="element-37">
            Es momento de reclamar tu{' '}
            <span className="text-gold-gradient" data-id="element-38">Poder Creador</span>
          </h2>

          <p className="text-lg text-white/80 mb-8 font-light leading-relaxed" data-id="element-39">
            El universo te trajo hasta aquí por una razón. No ignores el llamado
            a elevar tu vibración y transformar tu realidad para siempre.
          </p>

          <Button size="xl" className="w-full md:w-auto mx-auto mb-10 text-xl px-12 py-6" href="https://checkout.tusbeneficios.shop/cart/51012899700969:1" data-id="element-40">
            COMENZÁ TU TRANSFORMACIÓN HOY
          </Button>

          <div className="glass-panel inline-flex flex-col md:flex-row items-center gap-5 p-5 rounded-2xl border-white/10 mx-auto text-left" data-id="element-41">
            <div className="w-14 h-14 rounded-full bg-[#7c3aed]/20 flex items-center justify-center shrink-0" data-id="element-42">
              <ShieldCheck className="w-7 h-7 text-[#a855f7]" data-id="element-43" />
            </div>
            <div data-id="element-44">
              <h4 className="font-bold text-base text-white mb-1" data-id="element-45">
                Garantía Incondicional de 7 Días
              </h4>
              <p className="text-white/60 text-sm max-w-md" data-id="element-46">
                Prueba el kit completo sin riesgo. Si no sientes un cambio en tu
                energía, te devolvemos el 100% de tu inversión.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}